module Meevo.Plugins.Tippy {
    "use strict";
    export class SandboxSection extends Meevo.Components.CommonClasses.CommonSectionBase {


    }
}